import { useEffect, useRef } from "react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

export const TYPE_COLORS = {
  HMO: "#2563EB",
  House: "#DC2626",
  Flat: "#16A34A",
  Studio: "#EA580C",
  Garage: "#EC4899",
};

const iconCache = {};
export function pinIcon(color) {
  if (!iconCache[color]) {
    iconCache[color] = L.divIcon({
      className: "",
      html: `<svg width="30" height="42" viewBox="0 0 30 42" xmlns="http://www.w3.org/2000/svg"><path d="M15 0C6.7 0 0 6.7 0 15c0 10.5 15 27 15 27s15-16.5 15-27C30 6.7 23.3 0 15 0z" fill="${color}" stroke="white" stroke-width="1.5"/><circle cx="15" cy="15" r="6" fill="white"/></svg>`,
      iconSize: [30, 42],
      iconAnchor: [15, 42],
      popupAnchor: [0, -36],
    });
  }
  return iconCache[color];
}

async function geocode(query) {
  const res = await fetch(
    `https://photon.komoot.io/api/?q=${encodeURIComponent(query + ", UK")}&limit=1`
  );
  const data = await res.json();
  const f = data.features?.[0];
  return f ? [f.geometry.coordinates[1], f.geometry.coordinates[0]] : null;
}

export default function PropertyMap({ properties, testId, height = "h-80" }) {
  const containerRef = useRef(null);
  const mapRef = useRef(null);

  useEffect(() => {
    if (!containerRef.current || mapRef.current) return;
    const map = L.map(containerRef.current).setView([53.48, -2.24], 11);
    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
      attribution: "© OpenStreetMap contributors",
    }).addTo(map);
    mapRef.current = map;

    let cancelled = false;
    (async () => {
      const points = [];
      for (const p of properties) {
        try {
          let coords =
            p.lat != null && p.lng != null
              ? [Number(p.lat), Number(p.lng)]
              : p.location
                ? await geocode(p.location)
                : null;
          if (coords && !cancelled) {
            points.push(coords);
            L.marker(coords, { icon: pinIcon(TYPE_COLORS[p.type] || "#6B7280") })
              .addTo(map)
              .bindPopup(
                `<strong>${p.title}</strong><br/>${p.location}<br/><a href="/property/${p.id}">View property</a>`
              );
          }
        } catch (e) {}
      }
      if (!cancelled && points.length > 1) map.fitBounds(points, { padding: [40, 40] });
      else if (!cancelled && points.length === 1) map.setView(points[0], 15);
    })();

    return () => {
      cancelled = true;
      map.remove();
      mapRef.current = null;
    };
  }, [properties]);

  return (
    <div
      ref={containerRef}
      data-testid={testId}
      className={`${height} w-full rounded-2xl border border-[#E4DBD0] dark:border-[#352F2B] overflow-hidden`}
      style={{ zIndex: 0 }}
    />
  );
}
